import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function ComingSoon() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 80);

    return () => clearTimeout(timer);
  }, []);

  const courseName = slug
    ? slug
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "Upcoming Course";

  return (
    <div className="relative flex min-h-[calc(100dvh-80px)] w-full items-center justify-center overflow-hidden bg-[#FDFBF7] font-sans lg:min-h-[calc(100dvh-96px)]">
      <div
        className="
          pointer-events-none
          absolute
          -right-[180px]
          -top-[190px]
          h-[380px]
          w-[380px]
          rounded-full
          bg-[#DCE5ED]/80

          sm:-right-[200px]
          sm:-top-[220px]
          sm:h-[440px]
          sm:w-[440px]

          lg:-right-[220px]
          lg:-top-[260px]
          lg:h-[520px]
          lg:w-[520px]
        "
      />

      <div
        className="
          pointer-events-none
          absolute
          -bottom-[190px]
          -left-[180px]
          h-[380px]
          w-[380px]
          rounded-full
          bg-[#F4E4E7]/70

          sm:-bottom-[230px]
          sm:-left-[200px]
          sm:h-[460px]
          sm:w-[460px]

          lg:-bottom-[280px]
          lg:-left-[230px]
          lg:h-[560px]
          lg:w-[560px]
        "
      />

      <div
        className="
          pointer-events-none
          absolute
          left-5
          top-1/2
          hidden
          -translate-y-1/2
          grid-cols-4
          gap-3
          opacity-60

          sm:left-7
          sm:grid
          sm:gap-4

          lg:left-8
        "
      >
        {Array.from({ length: 24 }).map((_, index) => (
          <span
            key={index}
            className="
              h-1.5
              w-1.5
              rounded-full
              bg-[#B5C8DC]

              sm:h-1.5
              sm:w-1.5
            "
          />
        ))}
      </div>

      <div
        className="
          pointer-events-none
          absolute
          bottom-5
          right-5
          flex
          gap-2
          opacity-60

          sm:bottom-7
          sm:right-7
          sm:gap-3

          lg:bottom-8
          lg:right-10
        "
      >
        <span className="h-1.5 w-1.5 rounded-full bg-[#D52F3A] sm:h-2 sm:w-2" />
        <span className="h-1.5 w-1.5 rounded-full bg-[#563B72] sm:h-2 sm:w-2" />
        <span className="h-1.5 w-1.5 rounded-full bg-[#1F4F86] sm:h-2 sm:w-2" />
      </div>

      <main
        className={`
          relative
          z-10
          flex
          min-h-full
          w-full
          items-center
          justify-center
          px-5
          py-8
          text-center

          sm:px-8
          sm:py-10

          transition-all
          duration-1000
          ease-out

          ${visible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}
        `}
      >
        <div
          className="
            flex
            w-full
            max-w-5xl
            -translate-y-[clamp(24px,5vh,64px)]
            flex-col
            items-center
            justify-center
          "
        >
          <div
            className={`
              relative
              mb-5
              transition-all
              delay-100
              duration-700

              ${visible ? "scale-100 opacity-100" : "scale-75 opacity-0"}
            `}
          >
            <div
              className="
                absolute
                inset-0
                scale-[1.3]
                rounded-full
                border
                border-[#1F4F86]/10

                sm:scale-[1.35]
              "
            />

            <div
              className="
                absolute
                -inset-3
                rounded-full
                border
                border-[#1F4F86]/5

                sm:-inset-4
              "
            />

            <div
              className="
                relative
                flex
                h-[68px]
                w-[68px]
                items-center
                justify-center
                rounded-full
                bg-white
                shadow-[0_15px_45px_rgba(31,79,134,0.12)]

                sm:h-20
                sm:w-20

                md:h-24
                md:w-24
              "
            >
              <svg
                width="42"
                height="42"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="
                  h-8
                  w-8
                  animate-[float_3s_ease-in-out_infinite]

                  sm:h-9
                  sm:w-9

                  md:h-[42px]
                  md:w-[42px]
                "
              >
                <path
                  d="M4.5 14.5L8.8 10.2"
                  stroke="#D52F3A"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />

                <path
                  d="M8.8 10.2L12.4 13.8L19.5 6.5"
                  stroke="#D52F3A"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />

                <path
                  d="M15.2 6.5H19.5V10.8"
                  stroke="#1F4F86"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />

                <path
                  d="M5 19H19"
                  stroke="#563B72"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>

          <h1
            className={`
              w-full
              max-w-[95%]
              text-[44px]
              font-extrabold
              leading-[0.95]
              tracking-[-0.045em]

              sm:max-w-4xl
              sm:text-[58px]

              md:text-[70px]

              lg:text-[86px]

              xl:text-[92px]

              transition-all
              delay-300
              duration-1000

              ${
                visible
                  ? "translate-y-0 opacity-100"
                  : "translate-y-6 opacity-0"
              }
            `}
          >
            <span
              className="
                bg-gradient-to-r
                from-[#D52F3A]
                via-[#A52F55]
                to-[#1F4F86]
                bg-clip-text
                text-transparent
              "
            >
              coming{" "}
            </span>

            <span className="text-[#171B38]">soon!</span>
          </h1>

          <div
            className={`
              mt-4
              h-1
              w-20
              rounded-full
              bg-gradient-to-r
              from-[#D52F3A]
              via-[#A52F55]
              to-[#1F4F86]

              sm:mt-5
              sm:w-24

              transition-all
              delay-500
              duration-700

              ${visible ? "scale-x-100 opacity-100" : "scale-x-0 opacity-0"}
            `}
          />

          <div
            className={`
              mt-5
              px-2
              transition-all
              delay-500
              duration-700

              sm:mt-6

              ${
                visible
                  ? "translate-y-0 opacity-100"
                  : "translate-y-4 opacity-0"
              }
            `}
          >
            <p
              className="
                text-[14px]
                leading-6
                text-[#60718C]

                sm:text-base
                sm:leading-7

                md:text-lg
              "
            >
              Something exciting is on the way.
            </p>

            <p
              className="
                mt-0.5
                text-[14px]
                leading-6
                text-[#60718C]

                sm:text-base
                sm:leading-7

                md:text-lg
              "
            >
              <span className="font-bold text-[#171B38]">{courseName}</span> is
              being prepared for you.
            </p>
          </div>

          <div
            className={`
              mt-5
              transition-all
              delay-700
              duration-700

              sm:mt-6

              ${
                visible
                  ? "translate-y-0 opacity-100"
                  : "translate-y-4 opacity-0"
              }
            `}
          >
            <button
              type="button"
              onClick={() => navigate("/")}
              className="
                rounded-xl
                bg-gradient-to-r
                from-[#D52F3A]
                to-[#1F4F86]
                px-6
                py-2.5
                text-sm
                font-bold
                text-white
                shadow-lg
                shadow-[#1F4F86]/15
                transition-all
                duration-300

                hover:-translate-y-0.5
                hover:shadow-xl

                active:scale-[0.97]

                sm:px-7
                sm:py-3
              "
            >
              Back to Home
            </button>
          </div>
        </div>
      </main>

      <style>{`
        @keyframes float {
          0%,
          100% {
            transform: translateY(0px);
          }

          50% {
            transform: translateY(-5px);
          }
        }
      `}</style>
    </div>
  );
}
